import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { track } from "@/lib/api";

const KEY = "fsbe-favoritos";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };

export function useFavorites() {
  const [ids, setIds] = useState(read);
  useEffect(() => {
    const sync = () => setIds(read());
    window.addEventListener("fsbe-fav", sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener("fsbe-fav", sync); window.removeEventListener("storage", sync); };
  }, []);
  const toggle = useCallback((act) => {
    const cur = read();
    const has = cur.includes(act.id);
    const next = has ? cur.filter((x) => x !== act.id) : [...cur, act.id];
    localStorage.setItem(KEY, JSON.stringify(next));
    window.dispatchEvent(new Event("fsbe-fav"));
    toast.success(has ? "Removida de A minha Feira" : "Adicionada a A minha Feira", { description: act.title });
    if (!has) track("favorite", "", act.id);
  }, []);
  return { ids, has: (id) => ids.includes(id), toggle };
}
